import './MortgageCalculatorFields.css';

import React, { FunctionComponent } from 'react';
import { SliderNumberInput, Typography } from '@vtblife/uikit';
import { SliderNumberInputField, SliderMoneyInputField, Size } from '@vtblife/uikit/legacy';
import classname from '@search/classname/src';

import { useBankMortgageForm, UseBankMortgageFormProps } from '../../MinimalBanksMortgageFields/useBankMortgageForm';
import { MortgagePurposeEnum } from '../../MortgagePurposeEnum';
import { declensionYear } from '../../declensions';

const cn = classname.bind(null, 'BanksMortgageCalculatorFields');

const formatYear = (value: string) => {
    return `${value} ${declensionYear(Number(value.replace(',', '.')))}`;
};

export interface MinimalBanksMortgageFieldsProps extends UseBankMortgageFormProps {
    className?: string;
}

/**
 * Задаем несуществующий FORM_ID чтобы поля не отправлялись при submit
 */
const FORM_ID = 'FORM_ID';

export const BanksMortgageCalculatorFields: FunctionComponent<MinimalBanksMortgageFieldsProps & { isMobile?: boolean }> = React.memo(props => {
    const { className, isMobile, ...rest } = props;
    const {
        formState,
        handleFieldChange,
        calculatedFormValues: {
            ownAmount,
            propertyCost,
            term
        }
    } = useBankMortgageForm(rest);

    return (
        <div className={cn(undefined, undefined, className)}>
            <input hidden name='term' value={formState.term} readOnly />
            <input hidden name='purpose' value={MortgagePurposeEnum[formState.purpose]} readOnly />
            <input hidden name='regionId' value={formState.regionId} readOnly />
            <input hidden name='ownAmount' value={formState.ownAmount} readOnly />
            <input hidden name='propertyCost' value={formState.propertyCost} readOnly />
            <div className={cn('field', { grid: 'cost' })}>
                <SliderNumberInput
                    currency='RUB'
                    logarithmic
                    size='l'
                    inputMode='decimal'
                    label='Стоимость недвижимости'
                    max={propertyCost.max}
                    min={propertyCost.min}
                    step={propertyCost.step}
                    name='propertyCost'
                    onChange={handleFieldChange.bind(null, 'propertyCost')}
                    value={formState.propertyCost}
                />
            </div>
            <div className={cn('field', { grid: 'ownAmount' })}>
                <SliderMoneyInputField
                    contentAfter={isMobile ? undefined : <Typography variant='h4' color='black-400'>{ownAmount.percent}</Typography>}
                    form={FORM_ID}
                    inputMode='decimal'
                    label='Первоначальный взнос'
                    max={ownAmount.max}
                    min={ownAmount.min}
                    name='ownAmount'
                    onChange={handleFieldChange.bind(null, 'ownAmount')}
                    size={Size.Large}
                    step={ownAmount.step}
                    value={formState.ownAmount}
                    hideNoteSpace
                />
            </div>
            <div className={cn('field', { grid: 'term' })}>
                <SliderNumberInputField
                    form={FORM_ID}
                    formatter={formatYear}
                    inputMode='numeric'
                    label='Срок кредита'
                    max={term.max}
                    min={term.min}
                    name='term'
                    onChange={handleFieldChange.bind(null, 'term')}
                    size={Size.Large}
                    value={formState.term ? formState.term : 1}
                    hideNoteSpace
                />
            </div>
        </div>
    );
});
